import { Category } from '@/types/category'
import axios from './categoryInstance'

const updateCategory = async (category: any) => {
  const payload = {
    operation: "update",
    values:{
        ...category
    }
  }
  const response: any = await axios.patch(`/categories/${category.id}`, payload)
  return response.data
}

export default updateCategory
